import React, { useCallback, useState } from 'react';

import { Button, List } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import AlpaclassForm from '../../Form/Alpaclass';

interface IProps {
  other: any;
  onRemove: any;
  onEdit?: any;
  index: any;
  offer?: any;
}

const Alpaclass: React.FC<IProps> = ({ other, onRemove, onEdit, index, offer }) => {
  const [modal, setModal] = useState(false);
  const otherName = (item: any) => (item?.id ? item.method_name : item.name);
  const toggleModal = useCallback(() => {
    setModal(prev => !prev);
  }, []);
  const onOk = useCallback(
    (newItem: any, old: any) => {
      setModal(false);
      if (onEdit) onEdit(newItem, old);
    },
    [onEdit]
  );

  return (
    <>
      <List.Item
        className='border-outline-default mb-3 cursor-pointer rounded-xl border bg-(--uizz-antd-color-bg-container) px-4 py-3'
        onClick={() => toggleModal()}
        actions={
          other.can_modify
            ? [
                <Button
                  key='remove'
                  type='text'
                  className='m-0'
                  icon={<Icon.Trash2 size={16} className='size-4' />}
                  onClick={e => {
                    e.stopPropagation();
                    onRemove(otherName(other), index);
                  }}
                />
              ]
            : undefined
        }
      >
        <List.Item.Meta
          className='items-center'
          avatar={
            <div className='flex size-10 items-center justify-center'>
              <img src='/img/alpaclass.svg' width='40' height='40' alt='' />
            </div>
          }
          title={otherName(other)}
          description={other?.url}
        />
      </List.Item>
      {modal && (
        <AlpaclassForm other={other} isModal={true} open={modal} onClose={toggleModal} onOk={onOk} offer={offer} />
      )}
    </>
  );
};

export default Alpaclass;
